export default __webpack_public_path__ + "30634668b8020323e2931ee5722cadcd.png";